import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

/** Operator reference / order number for a stock adjustment (Thread Lab stock log). One component so the 64-char cap and copy can't drift across the six adjustment surfaces. */
interface AdjustmentReferenceFieldProps {
  id: string;
  value: string;
  onChange: (v: string) => void;
  labelClassName?: string;
}

export function AdjustmentReferenceField({
  id,
  value,
  onChange,
  labelClassName,
}: AdjustmentReferenceFieldProps) {
  const { t } = useTranslation('inventory');

  return (
    <div className="grid gap-2">
      <Label htmlFor={id} className={labelClassName}>
        {t('adjustmentReference.label')}{' '}
        <span className="font-normal text-muted-foreground">
          {t('adjustmentReference.optional')}
        </span>
      </Label>
      <Input
        id={id}
        value={value}
        maxLength={64}
        placeholder={t('adjustmentReference.placeholder')}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
